import { getRegionConfig } from "./constants";

export function getCurrencySymbol(regionCode: string): string {
    const r = getRegionConfig(regionCode);
    switch (r.currency) {
        case "SEK": return "kr";
        case "GBP": return "£";
        default: return "€";
    }
}

export function getStripeLocale(regionCode: string): string {
    return getRegionConfig(regionCode).lang;
}

/** Return numeric price in euros. regionPrice is already euros; CMS price is also euros. */
export function numericPrice(item: { regionPrice?: number; price?: number }): number {
    if ((item as any).regionPrice != null) return (item as any).regionPrice;
    return item.price ?? 0;
}

/** Format price for display. Prefers formattedPrice, then converts to euros. */
export function displayPrice(item: { formattedPrice?: string; regionPrice?: number; price?: number }, currencySymbol: string): string {
    if (item.formattedPrice) return item.formattedPrice;
    return `${numericPrice(item)}${currencySymbol}`;
}

function normalizeCountryValue(country?: string | null): string {
    return (country ?? "").trim().toLowerCase();
}

function countryToCurrencyCode(country?: string | null): string {
    const normalized = normalizeCountryValue(country);
    if (!normalized) return "";
    if (normalized === "suomi" || normalized === "fi" || normalized === "finland") return "EUR";
    if (normalized === "se" || normalized === "sverige" || normalized === "sweden") return "SEK";
    if (normalized === "uk" || normalized === "united kingdom" || normalized === "great britain") return "GBP";
    if (normalized === "ie" || normalized === "ireland") return "EUR";
    if (normalized.length === 2) {
        const code = normalized.toUpperCase();
        try {
            return getRegionConfig(code).currency;
        } catch (_err) {
            return "";
        }
    }
    return "";
}

export function getOrderCurrencySymbolFromCountry(country?: string | null): string {
    switch (countryToCurrencyCode(country)) {
        case "SEK": return "kr";
        case "GBP": return "£";
        case "EUR": return "€";
        default: return "";
    }
}

export function formatAmountWithCurrency(amount: number | string | null | undefined, currencySymbol: string): string {
    const value = amount ?? 0;
    return currencySymbol ? `${value} ${currencySymbol}` : `${value}`;
}
